import script from "./menu-item.vue?vue&type=script&lang=js"
export * from "./menu-item.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/pages/layouts/partials/sidebar/menu-item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "018fdd00"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('018fdd00', __exports__)) {
    console.log('reload')
    api.reload('018fdd00', __exports__)
  }
  
}


export default __exports__